import type { UserRole } from '@/types/user';

export function homePathForRole(role: UserRole | undefined): string {
  if (role === 'admin') return '/admin/dashboard';
  if (role === 'lawyer') return '/lawyer/dashboard';
  return '/dashboard';
}
